export default __webpack_public_path__ + "static/media/book.c0cc893b.png";